import { FormControl, ValidatorFn } from "@angular/forms";
import { ProviderUtilities } from "../providers/provider-utilities";

export class MaxDateValidator {
    
    static checkMaxDate(control:FormControl):ValidatorFn{

        let returnVal:any;

        let minDate;
        let minDateTotal = ProviderUtilities.minDate();
        const date = new Date();
        let month = (date.getMonth() + 1).toString();
        if (month.length < 2) month = '0' + month;
        let day = date.getDate().toString();
        if (day.length < 2) day = '0' + day;
        minDate = date.getFullYear() + '-' + month + '-' + day;

        if(control.value >= minDate){
         returnVal={'past_date':true}
        }

        if(control.value <= minDateTotal)
            returnVal={'invalid_date':true}
        
        
        if (control.value) {
            let originalDate = control.value.substr(0,10).split('-');
            let dateAsDate = ProviderUtilities.parseDate(control.value.substr(0,10));

            if(originalDate.length == 3 && (dateAsDate.getDate() != Number(originalDate[2]))){
                returnVal={'invalid_date': true};
            }
        }
        return returnVal;
    }
}


// WEBPACK FOOTER //
// ./src/validators/maxDate.ts